import React, { Component } from "react";
import { Drawer, Table, Tag, Icon } from "antd"; // Added Tag and Icon
import Request from "../../request";
import { connect } from "react-redux";


class PendingCourseCommission extends Component {
    state = {
        visible: true,
        arr: [],
        loading: false
    };

    componentDidMount() {
        this.loadCourses();
    }

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    onClose = () => {
        this.setState({ visible: false });
        setTimeout(() => {
            this.props.onClose();
        }, 400);
    };


    loadCourses = async (params = {}) => {
        const { arr } = this.props.param;
        this.setState({ loading: true });
        let response = await Request.getCourseByIds(arr);
        this.setState({ loading: false, arr: response.data });
    }


    render() {
        const { arr, loading } = this.state;
        const { title, count, bgColorClass, icon } = this.props.param;


        const column = [
            {
                title: 'Sr.',
                key: 'serialNumber',
                width: 60,
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: 'Course Name',
                key: 'courseName',
                render: (text, record) => (
                    <div>{record && record.course && record.course.courseName}</div>
                )
            },
            {
                title: 'University Name',
                key: 'universityInstitutionName',
                render: (text, record) => (
                    <div>{record && record.universityInstitutionName}</div>
                )
            }
        ];

        return (
            <Drawer
                title={
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '98%' }}>
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                            {/* Render the dynamic icon here. If it's a React component, it will render. */}
                            <span style={{ marginRight: 12, display: 'flex', fontSize: '20px' }}>
                                {icon ? icon : <Icon type="profile" />}
                            </span>
                            {title}
                        </span>
                        <Tag className="count-tag">{count} TOTAL</Tag>
                    </div>
                }
                placement="right"
                onClose={this.onClose}
                visible={this.state.visible}
                width={500}
                className={`dynamic-drawer ${bgColorClass}`}
            >
                <Table
                    columns={column}
                    ref={this.table}
                    loading={loading}
                    dataSource={arr}
                    rowKey={(record, index) => index}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 10,
                        pageSizeOptions: ["10", "20", "50"],
                    }}
                />
            </Drawer>
        );
    }
}

const mapStateToProps = ({ global, router }) => ({
    currentUser: global.currentUser,
});

export default connect(mapStateToProps, null)(PendingCourseCommission);